<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Stores
	import { devices } from 'src/stores/lists/devices';

	import { Text, Container, SelectCard, CardGrid } from '@Shelly/shelly-design-system';
	import { translateAndCapitalise } from '../../../../src/helpers/utilities';
	import { onMount } from 'svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let editableObject;
	let deviceActions = Object.assign({}, { ...editableObject });

	let device = deviceActions.device;
	let options = [];
	let _devices = Object.entries($devices);
	let isThermostat = deviceActions.mode === 'thermostat';
	const allowedCategories = ['relay', 'light'];

	let selectedCategoryValue = deviceActions.type || 'relay';

	const createIconForOption = (category) => {
		if (category === 'light') {
			return 'fa-light fa-lightbulb';
		} else if (category === 'relay') {
			return 'fa-light fa-outlet';
		}
	};

	const selectCategoryInitial = () => {
		_devices.forEach((_device: any) => {
			const _category = _device[1].category;
			if ($devices[device.id].category !== 'thermostat') {
				if (allowedCategories.includes(_category)) {
					if (!options.some((option) => option.value === _category)) {
						options = [
							...options,
							{
								title: translateAndCapitalise(_category),
								value: _category,
								icon: createIconForOption(_category),
							},
						];
					}
					if (typeof deviceActions.category === 'undefined') {
						deviceActions.category = _category;
					}
				}
			} else {
				if (_category === 'sensor') {
					deviceActions.category = _category;

					if (!options.some((option) => option.value === deviceActions.category)) {
						options = [
							...options,
							{
								title: translateAndCapitalise(deviceActions.category), // if it's not relay or light string won't work, not sure how to go inside this case
								value: deviceActions.category,
								icon: createIconForOption(deviceActions.category),
							},
						];
					}
				}
			}
		});
	};

	onMount(() => {
		selectCategoryInitial();
	});

	$: if (selectedCategoryValue) {
		if (editableObject.type != selectedCategoryValue) {
			deviceActions.selectedAction = undefined;
			deviceActions.selectedDevices = [];
			delete deviceActions.blindTime;
			deviceActions.ips = [];
			editableObject.selectedAction = undefined;
			editableObject.selectedDevices = [];
			delete editableObject.blindTime;
			editableObject.ips = [];
		}
		editableObject.type = selectedCategoryValue;
	}
</script>

<Container noScroll padding="0">
	{#if !isThermostat}
		<Text class="mb-m" element="h2">
			{$format('select_the_device_type', {
				default: 'Select the device type',
			})}
		</Text>

		<CardGrid gridGap="s" lg={290} sm={270} noPaddingBottom>
			{#each options as option}
				<SelectCard
					cardBgColor={$showNewLayout ? 'color-1' : undefined}
					size="m"
					title={option.title}
					variant="radio"
					icon={option.icon}
					type="horizontal"
					class="width-full"
					selected={selectedCategoryValue === option.value}
					on:click={() => {
						selectedCategoryValue = option.value;
					}}
				/>
			{/each}
		</CardGrid>
	{/if}
</Container>
